import React, { Component } from 'react';
import { endWait } from 'redux/actions/global';
import { connect } from 'react-redux';
import { SpinnerOverlay } from './loading_spinner';

interface IWaitComponent {
  endWait: any,
  waiting: any
}

class WaitComponent extends Component<IWaitComponent> {
  componentDidMount() {
    this.props.endWait();
  }

  render() {
    return this.props.waiting ? <SpinnerOverlay /> : null;
  }
}

function mapStateToProps(state) {
  return {
    waiting: state.global.waiting,
  };
}

const mapDispatchToProps = {
  endWait,
};

export default connect(mapStateToProps, mapDispatchToProps)(WaitComponent);
